module.exports = __webpack_public_path__ + "media/dorobek/assets/images/exclamation-mark-798bfd0fe2e28d3f501f4e5276c8c3ca.svg";